import { useOutletContext } from 'react-router-dom';

import { Panel, SkeletonLine } from '@crazyegginc/hatch';
import { CheckScript } from '/src/components/check-script/CheckScript';

// eslint-disable-next-line no-restricted-syntax
export default function CheckInstallationSettings() {
  const { site, siteId, siteName, loadingSite } = useOutletContext();

  let defaultSite = '';

  if (siteName) {
    defaultSite = siteName.startsWith('http') ? siteName : `https://${siteName}`;
  }

  if (loadingSite || !site) {
    return (
      <Panel className="mb-[50px]">
        <SkeletonLine className="w-full !rounded" />
        <br />
        <SkeletonLine className="w-1/2 !rounded" />
      </Panel>
    );
  }

  return (
    <Panel className="mb-[50px]">
      <CheckScript key={siteId || 'no-site'} defaultSite={defaultSite} />
    </Panel>
  );
}
